import { lazy } from 'react'
import Menu from '../pages/menu/Menu'
const MenuItems = lazy(() => import('../pages/menu/MenuItems'))
const Reports = lazy(() => import('../pages/reports'))
const Dashboard = lazy(() => import('../pages/dashboard'))

const Offices = lazy(() => import('../pages/offices'))
const OurClients = lazy(() => import('../pages/ourClients'))
const QuestionsAndAnswers = lazy(() => import('../pages/questionsAndAnswers'))
const Rentals = lazy(() => import('../pages/rentals'))
const Users = lazy(() => import('../pages/community'))
const MembershipTab = lazy(() => import('../pages/community/MembershipTab'))
const UserDetails = lazy(() => import('../pages/community/members/UserDetails'))
const officeOptions = lazy(() => import('../pages/office-options'))
const SendEmail = lazy(() => import('../pages/sendEmail'))
const EmailFeedback = lazy(() => import('../pages/feedback'))
const Specifications = lazy(() => import('../pages/settings/specifications'))
const MembershipPlans = lazy(() => import('../pages/settings/membershipPlans'))
const ViewNonMemberDetails = lazy(() => import('../pages/community/nonMembers/ViewNonMemberDetailsPage'))
const Events = lazy(() => import('../pages/events'))
const Payments = lazy(() => import('../pages/payments'))
const VariableExpenses = lazy(() => import('../pages/variableExpenses'))
const FixedExpenses = lazy(() => import('../pages/fixedExpenses'))
const PartnerDetails = lazy(() => import('../pages/community/partners/PartnerDetails'))
const OtherRevenue = lazy(() => import('../pages/otherRevenue'))
const RunningDashboard = lazy(() => import('../pages/runningDashboard'))
const Transfers = lazy(() => import('../pages/transfers'))
const MenuTransactions = lazy(() => import('../pages/menuTransactions'))


const routes = [
  { path: '/', element: Dashboard },
  { path: '/dashboard', element: Dashboard },
  { path: '/reports', element: Reports },
  {
    path: '/offices',
    element: Offices
  },
  {
    path: '/our-clients',
    element: OurClients
  },
  {
    path: '/questions-and-answers',
    element: QuestionsAndAnswers
  },
  {
    path: '/rentals',
    element: Rentals
  },
  {
    path: '/community',
    element: Users
  },
  {
    path: '/membership',
    element: MembershipTab
  },
  {
    path: '/community/details/:id',
    element: UserDetails
  },
  {
    path: '/office-options',
    element: officeOptions
  },
  {
    path: '/email',
    element: SendEmail
  },
  {
    path: '/feedback',
    element: EmailFeedback
  },
  {
    path: '/specifications',
    element: Specifications
  },
  {
    path: '/membership-plans',
    element: MembershipPlans
  },
  {
    path: '/community/non-members/details/:id',
    element: ViewNonMemberDetails
  },
  {
    path: '/menu',
    element: Menu
  },
  {
    path: '/menu/items/:id',
    element: MenuItems
  },
  {
    path: '/events',
    element: Events
  },
  {
    path: '/transactions',
    element: Payments
  },
  {
    path: '/variable-expenses',
    element: VariableExpenses
  },
  {
    path: '/fixed-expenses',
    element: FixedExpenses
  },
  {
    path: '/community/partners/:id',
    element: PartnerDetails
  },
  {
    path: '/other-revenue',
    element: OtherRevenue
  },
  {
    path: '/running-dashboard',
    element: RunningDashboard
  },
  {
    path: '/transfers',
    element: Transfers
  },
  {
    path: '/menu-transactions',
    element: MenuTransactions
  }

]

export default routes
